import type { TranslationKey } from './zh-CN';

export const en: Record<TranslationKey, string> = {
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.edit': 'Edit',
  'common.loading': 'Loading…',
  'common.error.load': 'Failed to load',
  'common.logout': 'Log out',
  'common.language': 'Interface language',
  'common.zh': '中文',
  'common.en': 'English',
  'nav.home': 'Workspace',
  'nav.library': 'Library',
  'nav.menus': 'Menus',
  'nav.ingredients': 'Ingredients',
  'nav.imports': 'Import recipe',
  'nav.scaling': 'Scaling',
  'nav.more': 'More',
  'nav.members': 'Members',
  'nav.roles': 'Access groups',
  'nav.audit': 'Activity',
  'nav.account': 'Account & Security',
  'auth.login': 'Sign in',
  'auth.loggingIn': 'Signing in…',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.loginFailed': 'Sign-in failed',
  'auth.forgot': 'Forgot your password? Contact an Owner to reset it.',
  'auth.title': 'Sign in',
  'auth.subtitle': 'Continue with your recipes, menus and R&D notes.',
  'account.title': 'Account & Security',
  'account.subtitle': 'Manage your display name, interface language and sign-in password.',
  'account.profile': 'Profile',
  'account.displayName': 'Display name',
  'account.saveProfile': 'Save profile',
  'account.profileSaved': 'Profile saved.',
  'account.passwordTitle': 'Change password',
  'account.currentPassword': 'Current password',
  'account.newPassword': 'New password',
  'account.confirmPassword': 'Confirm new password',
  'account.changePassword': 'Change password',
  'account.passwordChanged': 'Password changed. Other signed-in devices have been revoked.',
  'account.passwordHelp': 'Use at least 12 characters. This device stays signed in; other devices must sign in again.',
  'account.forcedTitle': 'Change your temporary password first',
  'account.forcedBody': 'An administrator set a temporary password for this account. Change it before continuing.',
  'account.forcedDone': 'Password updated. You can continue.',
  'members.title': 'Members & Access Groups',
  'members.subtitle': 'When someone leaves this restaurant workspace, disable their membership here. Identity history is retained and access to other workspaces is unaffected.',
  'members.add': 'Add member',
  'members.collapse': 'Collapse',
  'members.name': 'Name',
  'members.email': 'Email',
  'members.tempPassword': 'Temporary password',
  'members.tempPasswordHelp': 'The member must change it immediately after first sign-in.',
  'members.create': 'Create member',
  'members.active': 'Active',
  'members.disabled': 'Disabled in this workspace',
  'members.disable': 'Disable workspace member',
  'members.enable': 'Re-enable',
  'members.protected': 'Owner only',
  'members.mustChange': 'Password change required',
  'members.resetPassword': 'Reset password',
  'members.resetTitle': 'Set temporary password',
  'members.resetHelp': 'Saving signs this account out everywhere and requires a password change next time. Passwords are account-global; reset is refused here when the account belongs to multiple workspaces.',
  'members.resetDone': 'Temporary password set and member sessions revoked.',
  'members.createFailed': 'Failed to create member',
  'members.saveFailed': 'Failed to save member',
  'home.kicker': 'Kitchen workspace',
  'home.title': 'What are you working on today?',
  'home.subtitle': 'Start from a recipe, menu or scaling task.',
  'home.access': 'Current account',
  'audit.empty': 'No activity yet.',
  'audit.subtitle': 'See who changed what and when. Activity history is append-only.'
};
